import { useEffect, useState } from 'react'
import { DevOtpDto } from '@ivy-monorepo/shared'
import { adminService } from '../services/admin.service'

const DevOtpCard = () => {
  const [devOtp, setDevOtp] = useState<DevOtpDto | null>(null)
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    const fetchDevOtp = async () => {
      try {
        const response = await adminService.getDevOtp()
        setDevOtp(response)
      } catch (err) {
        console.log('Failed to fetch dev OTP', err)
      }
    }

    fetchDevOtp()
  }, [])

  if (!devOtp) {
    return null
  }

  const expiresAt = new Date(devOtp.expiresAt).toLocaleString()

  return (
    <div className="dev-otp-card">
      <span className="header">Dev OTP</span>
      <button
        type="button"
        className={`dev-otp-reveal${revealed ? ' is-revealed' : ''}`}
        onMouseEnter={() => setRevealed(true)}
        onMouseLeave={() => setRevealed(false)}
        onClick={() => setRevealed(current => !current)}
        aria-label={revealed ? 'Hide dev OTP' : 'Reveal dev OTP'}
      >
        <span className="dev-otp-code">{devOtp.otp}</span>
        <span className="dev-otp-hint" aria-hidden={revealed}>
          Hover or tap to reveal
        </span>
      </button>
      <p className="dev-otp-expiry">Rotates at {expiresAt}</p>
    </div>
  )
}

export default DevOtpCard
